export enum CoverageType {
  Covertee = "Covertree",
  External = "External",
}
